import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {RouteReuseStrategy, RouterModule} from '@angular/router';
import {HttpClientModule} from "@angular/common/http";

import { IonicModule, IonicRouteStrategy, NavParams } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {BackButtonComponent} from "@components/back-button/back-button.component";
import {SideMenuComponent} from "@components/sideMenu/side-menu/side-menu.component";
//import {InAppPurchase2} from "@awesome-cordova-plugins/in-app-purchase-2/ngx";
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '@environments/environment';
import {InboxPageModule} from "@pages/inbox/inbox.module";
import {FooterMenuModule} from "@components/footerMenu/footer-menu.module";
import {SharedModule} from "@components/unlogin-footer/shared.module";
import {CommonModule} from "@angular/common";
import {MyRouteReuseStrategy} from "./my-route-reuse.strategy";
//import { ImagePicker } from '@awesome-cordova-plugins/image-picker/ngx';


@NgModule({
  declarations: [AppComponent,
    //BackButtonComponent, SideMenuComponent
  ],
  //entryComponents: [],
  imports: [CommonModule,
    SideMenuComponent, BackButtonComponent,
    RouterModule, SharedModule, BrowserModule, IonicModule.forRoot({swipeBackEnabled: false}), AppRoutingModule, HttpClientModule, ServiceWorkerModule.register('ngsw-worker.js', {
    enabled: environment.production,
    // Register the ServiceWorker as soon as the application is stable
    // or after 30 seconds (whichever comes first).
    registrationStrategy: 'registerWhenStable:30000',
  }), InboxPageModule, FooterMenuModule],
  providers: [{ provide: RouteReuseStrategy, useClass: MyRouteReuseStrategy }],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    RouterModule
  ]
})
export class AppModule {}
